import {RefObject, useCallback} from "react";

import {IComparisonTableScrollDirection} from "../types/IComparisonTableScrollDirection";

interface IProps {
    tableRef: RefObject<HTMLElement | null>;
    headerRef: RefObject<HTMLElement | null>;
    tableRowsRef: RefObject<HTMLElement | null>;
}

export const useScrollNavigation = (props: IProps) => {
    const smoothScroll = (container: HTMLElement, startPosition: number, targetPosition: number, duration: number) => {
        const distance: number = targetPosition - startPosition;
        let startTime: number | null = null;

        function animation(currentTime: number): void {
            if (startTime === null) {
                startTime = currentTime;
            }
            const timeElapsed: number = currentTime - startTime;
            container.scrollLeft = ease(timeElapsed, startPosition, distance, duration);

            if (timeElapsed < duration) {
                requestAnimationFrame(animation);
            }
        }

        function ease(t: number, b: number, c: number, d: number): number {
            t /= d / 2;
            if (t < 1) {
                return (c / 2) * t * t + b;
            }
            t--;
            return (-c / 2) * (t * (t - 2) - 1) + b;
        }

        requestAnimationFrame(animation);
    };

    const tableScroll = useCallback(
        (scrollDirection: IComparisonTableScrollDirection) => {
            const headerContent = props.headerRef && props.headerRef.current;
            const tableContent = props.tableRef && props.tableRef.current;
            const tableRows = props.tableRowsRef && props.tableRowsRef.current;
            const scrollByElement = tableRows?.firstElementChild?.lastElementChild as HTMLSpanElement;

            if (tableContent && tableRows && headerContent && scrollByElement) {
                /*
                 * NOTE: We need to add small value to `scrollBy` value. CSS `calc` function may return decimal pixels value
                 * for example `187.78` (for CSS this will be a correct value), but DOM element `offsetWidth` will round this
                 * to the nearest full number. For us this small difference will break table scroll. Adding `scrollSafetyValue`
                 * will mitigate this problem.
                 */
                const scrollSafetyValue = 0.1;

                const scrollBy = scrollByElement.offsetWidth;
                const left = scrollDirection === IComparisonTableScrollDirection.RIGHT ? scrollBy + scrollSafetyValue : -scrollBy - scrollSafetyValue;

                smoothScroll(tableContent, tableContent.scrollLeft, tableContent.scrollLeft + left, 500);
                smoothScroll(headerContent, tableContent.scrollLeft, tableContent.scrollLeft + left, 500);
            }
        },
        [props.headerRef, props.tableRef, props.tableRowsRef]
    );

    const tableScrollToSpecificValue = useCallback(
        (left: number, shouldBeSmooth = true) => {
            const headerContent = props.headerRef && props.headerRef.current;
            const tableContent = props.tableRef && props.tableRef.current;
            const tableRows = props.tableRowsRef && props.tableRowsRef.current;
            const scrollByElement = tableRows?.firstElementChild?.lastElementChild as HTMLSpanElement;

            if (tableContent && tableRows && headerContent && scrollByElement) {
                if (shouldBeSmooth) {
                    smoothScroll(tableContent, tableContent.scrollLeft, tableContent.scrollLeft + left, 500);
                    smoothScroll(headerContent, tableContent.scrollLeft, tableContent.scrollLeft + left, 500);
                } else {
                    tableContent.scrollLeft = left;
                    headerContent.scrollLeft = left;
                }
            }
        },
        [props.headerRef, props.tableRef, props.tableRowsRef]
    );

    return {
        tableScroll,
        tableScrollToSpecificValue
    };
};
import {RefObject, useCallback} from "react";

import {IComparisonTableScrollDirection} from "../types/IComparisonTableScrollDirection";

interface IProps {
    tableRef: RefObject<HTMLElement | null>;
    headerRef: RefObject<HTMLElement | null>;
    tableRowsRef: RefObject<HTMLElement | null>;
}

export const useScrollNavigation = (props: IProps) => {
    const smoothScroll = (container: HTMLElement, startPosition: number, targetPosition: number, duration: number) => {
        const distance: number = targetPosition - startPosition;
        let startTime: number | null = null;

        function animation(currentTime: number): void {
            if (startTime === null) {
                startTime = currentTime;
            }
            const timeElapsed: number = currentTime - startTime;
            container.scrollLeft = ease(timeElapsed, startPosition, distance, duration);

            if (timeElapsed < duration) {
                requestAnimationFrame(animation);
            }
        }

        function ease(t: number, b: number, c: number, d: number): number {
            t /= d / 2;
            if (t < 1) {
                return (c / 2) * t * t + b;
            }
            t--;
            return (-c / 2) * (t * (t - 2) - 1) + b;
        }

        requestAnimationFrame(animation);
    };

    const tableScroll = useCallback(
        (scrollDirection: IComparisonTableScrollDirection) => {
            const headerContent = props.headerRef && props.headerRef.current;
            const tableContent = props.tableRef && props.tableRef.current;
            const tableRows = props.tableRowsRef && props.tableRowsRef.current;
            const scrollByElement = tableRows?.firstElementChild?.lastElementChild as HTMLSpanElement;

            if (tableContent && tableRows && headerContent && scrollByElement) {
                /*
                 * NOTE: We need to add small value to `scrollBy` value. CSS `calc` function may return decimal pixels value
                 * for example `187.78` (for CSS this will be a correct value), but DOM element `offsetWidth` will round this
                 * to the nearest full number. For us this small difference will break table scroll. Adding `scrollSafetyValue`
                 * will mitigate this problem.
                 */
                const scrollSafetyValue = 0.1;

                const scrollBy = scrollByElement.offsetWidth;
                const left = scrollDirection === IComparisonTableScrollDirection.RIGHT ? scrollBy + scrollSafetyValue : -scrollBy - scrollSafetyValue;

                smoothScroll(tableContent, tableContent.scrollLeft, tableContent.scrollLeft + left, 500);
                smoothScroll(headerContent, tableContent.scrollLeft, tableContent.scrollLeft + left, 500);
            }
        },
        [props.headerRef, props.tableRef, props.tableRowsRef]
    );

    const tableScrollToSpecificValue = useCallback(
        (left: number, shouldBeSmooth = true) => {
            const headerContent = props.headerRef && props.headerRef.current;
            const tableContent = props.tableRef && props.tableRef.current;
            const tableRows = props.tableRowsRef && props.tableRowsRef.current;
            const scrollByElement = tableRows?.firstElementChild?.lastElementChild as HTMLSpanElement;

            if (tableContent && tableRows && headerContent && scrollByElement) {
                if (shouldBeSmooth) {
                    smoothScroll(tableContent, tableContent.scrollLeft, tableContent.scrollLeft + left, 500);
                    smoothScroll(headerContent, tableContent.scrollLeft, tableContent.scrollLeft + left, 500);
                } else {
                    tableContent.scrollLeft = left;
                    headerContent.scrollLeft = left;
                }
            }
        },
        [props.headerRef, props.tableRef, props.tableRowsRef]
    );

    return {
        tableScroll,
        tableScrollToSpecificValue
    };
};
